import React, { useState, useMemo, useEffect } from 'react';
import Table from '../common/Table/Table';
import EditButton from '../common/ActionButton/EditButton';
import AddToTodoButton from '../common/ActionButton/AddToTodoButton';
import WhatsAppButton from '../common/ActionButton/WhatsAppButton';
import MailButton from '../common/ActionButton/MailButton';
import DeleteButton from '../common/ActionButton/DeleteButton';
import { fetchActivityLogs } from '../../api/leadActivityLogs';
import SelectedPopup from '../common/selectedPopup';
import { API_BASE } from '../../config';
import '../../style/PageTable.css';
import { deleteEntity } from '../../utlis/deleteEntity';
import { sortArrayByKey } from '../../utlis/sortingUtils';
import '../../style/PageTable.css';

const LeadsTable = ({
  filteredLeads,
  handleRowClick,
  selectedLead,
  closePopup,
  handleEditClick,
  addToTodo,
  onLeadDeleted
}) => {

  const deleteLead = async (leadId) => {
    await deleteEntity({
      entityType: 'leads',
      entityId: leadId,
      onDeleted: onLeadDeleted
    });
  };

  const [sortConfig, setSortConfig] = useState({ key: 'posted_on', direction: 'descending' });
  const [activityLogs, setActivityLogs] = useState([]);

  useEffect(() => {
    const fetchLogs = async () => {
      if (selectedLead && selectedLead.lead_id) {
        try {
          const logs = await fetchActivityLogs(selectedLead.lead_id);
          setActivityLogs(Array.isArray(logs) ? logs : []);
        } catch (error) {
          console.error('Failed to fetch activity logs:', error);
          setActivityLogs([]);
        }
      } else {
        setActivityLogs([]);
      }
    };
    fetchLogs();
  }, [selectedLead]);

  const columns = [
    { header: 'Lead ID', key: 'lead_id' },
    { header: 'Contact', key: 'contact_name' },
    { header:'Phone', key:'contact_phone'},
    { header:'Email', key:'contact_email'},
    { header: 'Posted On', key: 'posted_on' },
    { header: 'Status', key: 'responded' },
    { header: 'Source', key: 'source' },
    { header: 'Actions', className: 'actions-header' }
  ];

  const sortedLeads = useMemo(() => {
    return sortArrayByKey(filteredLeads, sortConfig.key, sortConfig.direction);
  }, [filteredLeads, sortConfig]);

  const handleSort = (key) => {
    let direction = 'descending';
    if (sortConfig.key === key && sortConfig.direction === 'descending') {
      direction = 'ascending';
    }
    setSortConfig({ key, direction });
  };

  const renderRow = (lead) => (
    <>
      <td>{lead.lead_id}</td>
      <td>{lead.contact_name}</td>
      <td>{lead.contact_phone}</td>
      <td>{lead.contact_email}</td>
      <td>{new Date(lead.posted_on).toLocaleDateString()}</td>
      <td>{lead.responded}</td>
      <td>{lead.source}</td>
      <td className="actions-cell">
        <EditButton 
          onClick={() => handleEditClick(lead)}
          className="lead-edit-btn"
          title="Edit"
        />
        {lead.contact_phone && (
          <WhatsAppButton 
            className="whatsapp-btn" 
            title="Send WhatsApp message" 
            phone={lead.contact_phone} />
        )}
        {lead.contact_email && (
          <MailButton 
            className="mail-btn" 
            title="Send Email"
            email={lead.contact_email} />
        )}
        <DeleteButton
          title="Delete"
          className="delete-btn"
          onClick={() => deleteLead(lead.lead_id)}
        />
        <AddToTodoButton
          title="Add to Todo"
          onClick={() => addToTodo(lead)}
          className="add-to-todo-btn"
        />
      </td>
    </>
  );

  return (
    <div>
      <Table 
        columns={columns} 
        data={sortedLeads} 
        renderRow={renderRow} 
        className="page-table table-container"
        onRowClick={handleRowClick} 
        onSort={handleSort}
        sortConfig={sortConfig}
      />
      {selectedLead && (
        <SelectedPopup
          selectedItem={selectedLead}
          activityLogs={activityLogs}
          closePopup={closePopup}
          handleEditClick={handleEditClick}
          itemType="lead"
        />
      )}
    </div>
  );
};

export default LeadsTable;
